import React, { useEffect, useMemo, HTMLAttributes } from "react";
import { useTransition, animated, UseTransitionProps, AnimatedProps } from "@react-spring/web";

interface RevealProps {
  show: boolean;
  className?: string;
  type?: 'fade' | 'slide-up';
  config?: {
    distance?: number;
  }
  delay?: number;
  children: React.ReactNode;
}

const AnimatedDiv = animated.div as React.FC<AnimatedProps<HTMLAttributes<HTMLDivElement>>>;

const Reveal: React.FC<RevealProps> = ({ show, className, type = 'fade', children, config, delay }) => {

  const transistionConfig = useMemo<UseTransitionProps>(() => {
    const defaultConfig = {
      delay: delay || 0,
    };

    switch (type) {
      case 'slide-up': {
        const distance = `${config?.distance || 10}px`;
        return {
          ...defaultConfig,
          from: { transform: `translateY(${distance})`, opacity: 0 },
          enter: { transform: `translateY(0)`, opacity: 1 },
          leave: { transform: `translateY(-${distance})`, opacity: 0 },
        };
      }
      default:
        return {
          ...defaultConfig,
          from: { opacity: 0 },
          enter: { opacity: 1 },
          leave: { opacity: 0 },
        };
    }
  }, [type]);
  

  const transitions = useTransition(show, {
    ...transistionConfig,
  });

  useEffect(() => {
  }, [show]);

  return transitions((style, item) => (item) && (
    <AnimatedDiv style={style} className={className}>
      {children}
    </AnimatedDiv>
  ))
};

export default Reveal;